import React, { useEffect, useState } from "react";

function TextField2({
  label,
  value = "",
  mandatory = false,
  noborder = false,
  type = "text",
  mandatory_characters = [],
  min = 0,
  max = 100,
  onChange = () => {},
  className = "",
  autoComplete = "off",
  transparent = false,
  onEnter = () => {},
  focusOnStart = false,
  disabled = false,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };

  const [focus, setFocus] = useState(false);

  const handleChange = (e) => {
    onChange(e);
  };

  let border_color =
    (mandatory && !value) ||
    mandatory_characters.some((char) => !value.includes(char))
      ? "border-red-500"
      : focus
      ? "border-blue-300"
      : "border-gray-300";

  return (
    <div
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      className={`w-full h-9 relative flex flex-row select-none items-center py-1 text-black ${className} 
      w-full
      px-1  
       
     
      rounded-xl
      ${
        noborder
          ? ""
          : focus
          ? "border-2 outline-1 outline-blue-100"
          : "border    "
      }
      ${border_color}
      
      outline-none
      transition
      ease-in-out
      duration-150
      ${
        disabled
          ? "bg-neutral-100 text-shadow_25"
          : transparent
          ? "bg-transparent font-semibold"
          : "bg-white"
      }      
    `}
    >
      <input
        disabled={disabled}
        type={type} // Force text input type to avoid unwanted number input behavior
        min={min}
        max={max}
        placeholder={label}
        value={value === null ? "" : value}
        autoFocus={focusOnStart}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        autoComplete={autoComplete}
        className={`
          h-full w-full
         
          rounded-lg
          
       px-1  
          outline-none
          transition
          ease-in-out
          duration-150
         bg-transparent     
        `}
        style={{
          fontSize: "14px",
        }}
      />
    </div>
  );
}

export default TextField2;
